import React from 'react';
import { connect } from 'react-redux';
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import Draggable from 'react-draggable';
import _ from 'lodash';
import moment from 'moment';

import { saveConfig, updateMetrics } from '../../../components/Filter/FilterActions';

class FlowStats extends React.Component {
  constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.props.close();
    this.props.saveConfig();
  }

  render() {
    if (!this.props.metrics || !this.props.data || !this.props.data.length) {
      return <div></div>;
    }

    let rows = this.props.data.map((item) => {
      return (
        <tr key={item.list}>
          <td>
            <div className="label_box" style={{ background: item.color }}></div>
            {item.list}
          </td>
          <td>{item.avgArrivalRate > 0 ? item.avgArrivalRate.toFixed(2) : '---'}</td>
          <td>{item.avgThroughput > 0 ? item.avgThroughput.toFixed(2) : '---'}</td>
          <td>{item.avgDailyWIP > 0 ? item.avgDailyWIP.toFixed(2) : '---'}</td>
          <td>
            {item.avgCycleTime > 0
              ? `${item.avgCycleTime.toFixed(2)} (${moment
                  .duration(item.avgCycleTime, 'days')
                  .format(this.props.timePrecision, { trim: 'mid both' })})`
              : '---'}
          </td>
        </tr>
      );
    });

    return (
      <Draggable defaultPosition={{ x: 95, y: 85 }} axis="both" bounds="parent">
        <div id={this.props.id} className="box_white_shadow table_metrics">
          <h3>Process Metrics</h3>
          <p>All values are calculated averages</p>
          <Button className="btn-close" onClick={this.handleClose}>
            &times;
          </Button>
          <Table condensed>
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>
                  Arrival Rate <br />
                  items/day
                </th>
                <th>
                  Throughput <br />
                  items/day
                </th>
                <th>
                  Daily WIP <br />
                  items
                </th>
                <th>
                  Cycle Time <br />
                  days
                </th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </Table>
        </div>
      </Draggable>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    close: () => dispatch(updateMetrics(false, 'cfd')),
    saveConfig: () => dispatch(saveConfig()),
  };
};

const mapStateToProps = (state) => {
  return {
    timePrecision: state.filters.timePrecision,
    metrics: state.filters.cfd.metrics,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FlowStats);
